export enum TypeInstance {
  OYESK_FRANCE = 'oyesk',
  OYESK_LUX = 'lux'
}

export enum DataInstance {
  POST_DATA_PLATFORM = 'DataPlatform',
  GPS = 'gps'
}
